import { useModal } from "@/common/contexts/Modal.context";
import { Button } from "antd";

export default function StayInPageButton() {
  const { closeModal } = useModal();
  const onClick = () => {
    closeModal();
  };
  return (
    <Button
      className="h-10 text-base font-inter font-semibold border-primary text-primary"
      onClick={onClick}
    >
      Stay in page
    </Button>
  );
}
